import { FunctionalComponent, h } from '@stencil/core'; // eslint-disable-line @typescript-eslint/no-unused-vars
import PartnerWizardModalChannelsHeaderTemplate from './partner-wizard-modal-channels-header.template';
import PartnerWizardModalChannelsTemplate from './partner-wizard-modal-channels.template';
import PartnerWizardModalPartnersHeaderTemplate from './partner-wizard-modal-partners-header.template';
import PartnerWizardModalPartnersTemplate from './partner-wizard-modal-partners.template';
import { PartnerWizardComponent } from '../../cwc-partner-wizard';

/**
 * Definition of  parameters that the template needs to work.
 */
interface PartnerWizardModalTemplateProps {
  /**
   * The class instance that provides controller functionality for the template
   */
  controller: PartnerWizardComponent;
  // Specify parameters that are required to be passed down to the template here.
}

const PartnerWizardModalTemplate: FunctionalComponent<PartnerWizardModalTemplateProps> = ({ controller }) => (
  <cwc-component-modal ref={(el) => (controller.modal = el)}>
    <div slot="header-items">
      <header>
        {controller.renderState.currentStep === 'channels' && (
          <PartnerWizardModalChannelsHeaderTemplate controller={controller} />
        )}

        {controller.renderState.currentStep === 'partners' && (
          <PartnerWizardModalPartnersHeaderTemplate controller={controller} />
        )}
      </header>
    </div>

    <main>
      {controller.renderState.currentStep === 'channels' && (
        <PartnerWizardModalChannelsTemplate controller={controller} />
      )}

      {controller.renderState.currentStep === 'partners' && (
        <PartnerWizardModalPartnersTemplate controller={controller} />
      )}
    </main>
  </cwc-component-modal>
);

export default PartnerWizardModalTemplate;
